(function(){
  // quote-steps.js
  // Vanilla JS multi-step quote wizard.
  // Persists state in sessionStorage under key 'quoteState'.

  var STORAGE_KEY = 'quoteState';
  // Pricing endpoint (override via data-get-pricing-endpoint on section if needed)
  var GET_PRICING_ENDPOINT = 'https://yourlocalbackend.vercel.app/api/get-pricing-zone';
  // Loader animation path
  var LOADER_ANIMATION_URL = null;

  function qs(selector, ctx){ return (ctx||document).querySelector(selector); }
  
  // Get endpoint URLs from section data attributes
  function getEndpoint(name) {
    var section = qs('.quote-steps');
    if (!section) return null;
    return section.getAttribute('data-' + name + '-endpoint');
  }
  function qsa(selector, ctx){ return (ctx||document).querySelectorAll(selector); }

  function loadState(){
    try{ return JSON.parse(sessionStorage.getItem(STORAGE_KEY)) || {}; }catch(e){ return {}; }
  }
  function saveState(state){ sessionStorage.setItem(STORAGE_KEY, JSON.stringify(state)); }

  function getQueryParam(name){
    var params = new URLSearchParams(window.location.search);
    return params.get(name);
  }

  function showStep(index){
    var steps = qsa('.qs-step');
    steps.forEach(function(s){ s.classList.remove('active'); });
    var el = document.querySelector('.qs-step[data-step="'+index+'"]');
    if (el) el.classList.add('active');
    var current = qs('#qs-current'); if (current) current.textContent = index;
    // update visual progress dots
    updateProgress(index);
    // Hide the global Back/Next controls when on the account/create step (step 4)
    try{
      var controls = qs('.quote-steps__controls');
      if (controls) {
        // hide controls on Step 1 (initial property details), Step 2 (customer details)
        // and Step 4 (account/create)
        if (Number(index) === 1 || Number(index) === 2 || Number(index) === 4) controls.style.display = 'none';
        else controls.style.display = '';
      }
    }catch(e){/* ignore */}
    // Ensure the main steps wrapper is visible when navigating between steps
    try{
      var stepsWrap = qs('#qs-steps');
      if (stepsWrap) stepsWrap.style.display = '';
    }catch(e){}
  }

  function updateProgress(index){
    var labels = {1: 'Property', 2: 'Details', 3: 'Quote', 4: 'Payment'};
    var dots = qsa('.qs-dot');
    dots.forEach(function(d){
      var step = parseInt(d.getAttribute('data-step'),10) || 0;
      // set a readable label for each dot (used by CSS ::before)
      try{ d.setAttribute('data-label', labels[step] || ''); }catch(e){}
      d.classList.remove('active','completed');
      // default show the step number
      try{ d.textContent = step; }catch(e){}
      if (step < Number(index)) {
        d.classList.add('completed');
        try{ d.textContent = '✓'; }catch(e){}
      } else if (step === Number(index)) {
        d.classList.add('active');
      }
    });
    var label = qs('#qs-current'); if (label) label.textContent = index;

    // update connectors width and colour
    try{ updateConnectors(); }catch(e){ console.warn('updateProgress connectors failed', e); }
  }

  // Create/update inline connector elements and size them to bridge to the next dot
  function updateConnectors(){
    var dots = Array.prototype.slice.call(qsa('.qs-dot')) || [];
    var wrap = qs('.qs-dots');
    if (!dots.length || !wrap) return;
    // remove any existing connectors attached to wrap so we can recreate cleanly
    try{ Array.prototype.slice.call(wrap.querySelectorAll('.qs-connector')).forEach(function(n){ n.parentNode && n.parentNode.removeChild(n); }); }catch(e){}
    var wrapRect = wrap.getBoundingClientRect();
    for (var i=0;i<dots.length;i++){
      var d = dots[i];
      // hide for last dot (no connector)
      if (i === dots.length - 1) continue;
      // create connector element appended to wrap
      var conn = document.createElement('span'); conn.className = 'qs-connector';
      wrap.appendChild(conn);
      try{
        var r1 = d.getBoundingClientRect();
        var r2 = dots[i+1].getBoundingClientRect();
        // compute left relative to wrap and width between dots
        var overlap = 8; // pixels to overlap into dot edge for visual join
        var left = Math.round(r1.right - wrapRect.left - overlap);
        var width = Math.round((r2.left - r1.right) + (overlap * 2));
        if (width < 8) width = 8;
        conn.style.position = 'absolute';
        conn.style.left = left + 'px';
        conn.style.width = width + 'px';
        conn.style.display = 'block';
        // color based on whether this step is completed
        if (d.classList.contains('completed')) conn.style.background = '#39C8C0'; else conn.style.background = '#e6e6e6';
      }catch(e){ console.warn('connector sizing failed', e); conn.style.display = 'none'; }
    }
  }

  function collectStep1(state){
    state.service = state.service || {};
    var addr = (qs('#qs-address') && qs('#qs-address').value) || '';
    state.service.address = addr;
    
    // Always clear old postcode first, then extract from current address
    state.service.postcode = null;
    
    var postcode = null;
    var hiddenPc = qs('#qs-postcode');
    if (hiddenPc && hiddenPc.value) {
      postcode = hiddenPc.value;
    } else if (window && window.IdealPostcodes && window.IdealPostcodes.postcode) {
      postcode = window.IdealPostcodes.postcode;
    } else if (addr) {
      var re = /([A-Z]{1,2}\d[A-Z\d]?\s*\d[A-Z]{2})/i;
      var m = addr.match(re);
      if (m && m[1]) postcode = m[1];
    }
    if (postcode) {
      state.service.postcode = postcode.toUpperCase().trim();
      console.log('Collected postcode from step 1:', state.service.postcode);
    }
    
    // Clear pricing cache to force fresh fetch with new postcode
    if (state.summary) {
      state.summary.pricing = null;
    }
    
    state.service.property = qs('#qs-property-type').value;
    state.service.windows = parseInt(qs('#qs-windows').value,10) || 0;
    var addons = [];
    qsa('.qs-addon').forEach(function(cb){ if (cb.checked) addons.push(cb.value); });
    state.service.addons = addons;
    saveState(state);
    return state;
  }

  function collectStep2(state){
    state.customer = state.customer || {};
    // prefer visible / primary inputs, but fall back to account inputs on Step 4
    state.customer.first = (qs('#qs-first') && qs('#qs-first').value) || (qs('#qs-account-first') && qs('#qs-account-first').value) || '';
    state.customer.last = (qs('#qs-last') && qs('#qs-last').value) || (qs('#qs-account-last') && qs('#qs-account-last').value) || '';
    state.customer.email = (qs('#qs-email') && qs('#qs-email').value) || (qs('#qs-account-email') && qs('#qs-account-email').value) || '';
    state.customer.phone = (qs('#qs-phone') && qs('#qs-phone').value) || (qs('#qs-account-phone') && qs('#qs-account-phone').value) || '';
    // capture address fields that might appear on step 2 (fall back to service.address)
    try{
      var addrVal = (qs('#qs-address') && qs('#qs-address').value) || (qs('#qs-customer-address') && qs('#qs-customer-address').value) || (state.service && state.service.address) || '';
      if (addrVal) {
        state.customer.address = addrVal;
        state.service = state.service || {};
        state.service.address = addrVal;
      }
    }catch(e){}
    // capture marketing opt-in checkbox (primary selector used in theme)
    try{
      var mEl = qs('#qs-marketing-optin') || qs('#qs-marketing') || qs('#qs-marketing-opt-in') || qs('input[name="marketing_opt_in"]') || qs('input[name="accepts_marketing"]') || qs('input[name="subscribe"]');
      if (mEl) {
        state.customer.marketing_optin = !!(mEl.checked || String(mEl.value || '').toLowerCase() === 'true');
      }
    }catch(e){}
    // Persist first/last/marketing to sessionStorage for Step 4 hydrator usage
    try{ sessionStorage.setItem('quote_customer_first', (state.customer.first || '').trim()); sessionStorage.setItem('quote_customer_last', (state.customer.last || '').trim()); }catch(e){}
    try{ sessionStorage.setItem('quote_customer_marketing_optin', state.customer.marketing_optin ? '1' : '0'); }catch(e){}
    saveState(state);
    return state;
  }

  // Simple placeholder pricing function
  function pricingFor(state){
    var basePerWindow = 10; // $10 per window
    var windows = (state.service && state.service.windows) || 0;
    var subtotal = basePerWindow * windows;
    var propertyMultiplier = 1;
    if (state.service && state.service.property === 'house') propertyMultiplier = 1.2;
    if (state.service && state.service.property === 'commercial') propertyMultiplier = 1.5;
    var addonsTotal = 0;
    (state.service && state.service.addons || []).forEach(function(a){
      if (a === 'deep_clean') addonsTotal += 20;
      if (a === 'screens') addonsTotal += 15;
      if (a === 'track_clean') addonsTotal += 10;
    });
    var total = Math.round((subtotal * propertyMultiplier) + addonsTotal);
    return { subtotal: subtotal, addons: addonsTotal, multiplier: propertyMultiplier, total: total };
  }

  // Format number to GBP with 2 decimals
  function formatGBP(n){
    var num = Number(n) || 0; return '£' + num.toFixed(2);
  }

  // Extract outward postcode (part before space) and normalise
  function extractOutwardCode(s){
    if (!s) return null;
    s = String(s).trim().toUpperCase();
    if (!s) return null;
    var parts = s.split(/\s+/);
    return parts[0] || s;
  }

  // Get best postcode available: priority -> state.service.postcode, #qs-postcode hidden input,
  // window.IdealPostcodes integration, then regex from #qs-address. Returns normalized postcode or null.
  function getPostcode(state){
    var source = 'none';
    var pc = null;
    try{
      if (state && state.service && state.service.postcode) {
        pc = state.service.postcode;
        source = 'state';
      }
      if (!pc) {
        var el = qs('#qs-postcode');
        if (el && el.value) { pc = el.value; source = 'hidden-input'; }
      }
      if (!pc && window && window.IdealPostcodes) {
        try{ if (window.IdealPostcodes.postcode) { pc = window.IdealPostcodes.postcode; source = 'idealpostcodes'; } }
        catch(e){}
      }
      // If still not found, try to extract from free text address using regex
      if (!pc) {
        var addr = (qs('#qs-address') && qs('#qs-address').value) || (state && state.service && state.service.address) || '';
        var re = /([A-Z]{1,2}\d[A-Z\d]?\s*\d[A-Z]{2})/i;
        var m = addr.match(re);
        if (m && m[1]) { pc = m[1]; source = 'regex'; }
      }
    }catch(e){}

    if (!pc) { console.log('postcode source:', source, null); return null; }
    // normalize: uppercase, remove non-alphanum, ensure single space before last 3 chars
    var norm = String(pc).toUpperCase().replace(/[^A-Z0-9]/g, '');
    if (norm.length >= 5) {
      var out = norm.slice(0, norm.length - 3);
      var inw = norm.slice(-3);
      norm = out + ' ' + inw;
    }
    console.log('postcode source:', source, norm);
    return norm;
  }

  // Normalize phone to E.164 for UK simple cases
  async function normalizePhoneToE164(phone) {
    if (!phone) return undefined;
    phone = String(phone).trim();
    if (phone.indexOf('+') === 0) return phone;
    if (phone.indexOf('0') === 0) return '+44' + phone.slice(1);
    return phone;
  }

  // Non-blocking preflight upsert to ensure customer email/phone/accepts_marketing present
  // Debounced via sessionStorage key 'quote_customer_upserted'
  async function upsertCustomerPreflight(state) {
    try {
      if (!state || !state.customer || !state.customer.email) return null;
      var email = state.customer.email || '';
      try{ var already = sessionStorage.getItem('quote_customer_upserted') || ''; if (already === email) return null; }catch(e){}
      var payload = {
        email: state.customer.email,
        first_name: state.customer.first || state.customer.first_name || undefined,
        last_name: state.customer.last || state.customer.last_name || undefined,
        phone: await normalizePhoneToE164(state.customer.phone || state.customer.tel),
        address: (state.service && state.service.address) || state.address || undefined,
        postcode: (state.service && state.service.postcode) || state.postcode || undefined,
        marketing_optin: Boolean((state.customer && state.customer.marketing_optin) || false)
      };
      console.log('preflight upsert payload', payload);
      var tryFetch = async function(attempt) {
        attempt = attempt || 1;
        try {
          var endpoint = getEndpoint('shopify-order') || 'https://yourlocalbackend.vercel.app/api/create-shopify-order';
          var res = await fetch(endpoint, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload) });
          if (!res.ok) {
            var text = await res.text().catch(function(){return null;});
            console.warn('preflight upsert failed', res.status, text);
            throw new Error('upsert failed');
          }
          try{ sessionStorage.setItem('quote_customer_upserted', payload.email); }catch(e){}
          return await res.json().catch(function(){return null;});
        } catch (err) {
          if (attempt < 2) {
            await new Promise(function(r){ setTimeout(r, 500); });
            return tryFetch(attempt + 1);
          }
          console.warn('preflight upsert error (non-blocking)', err);
          return null;
        }
      };
      return tryFetch(1);
    } catch (e) { console.warn('upsertCustomerPreflight error', e); return null; }
  }

  // Async render for Step 3 summary/pricing UI. Fetches postcode pricing and renders selectable cards.
  async function renderSummary(state){
    var breakdown = qs('#qs-breakdown'); if (!breakdown) return;
    breakdown.innerHTML = '<div id="qs-loader" style="text-align:center;padding:2rem;"><div style="max-width:200px;margin:0 auto;"></div></div>';
    
    // Load and render Lottie animation
    try{
      var lottieContainer = breakdown.querySelector('#qs-loader > div');
      if (lottieContainer && typeof lottie !== 'undefined' && LOADER_ANIMATION_URL) {
        lottie.loadAnimation({
          container: lottieContainer,
          renderer: 'svg',
          loop: true,
          autoplay: true,
          path: LOADER_ANIMATION_URL
        });
      }
    }catch(e){ console.warn('Lottie loader failed', e); }

    state.summary = state.summary || {};

    // determine postcode using integration or regex
    var postcode = getPostcode(state);

    // Always fetch pricing from backend API (sends postcode or null for Default zone)
    try{
      var controller = new AbortController();
      var timeout = setTimeout(function(){ controller.abort(); }, 7000);
      var res = await fetch(GET_PRICING_ENDPOINT, {
        method: 'POST', 
        headers: { 'Content-Type': 'application/json' }, 
        body: JSON.stringify({ postcode: postcode || null }), 
        signal: controller.signal
      });
      clearTimeout(timeout);
      var text = await res.text();
      var data = null;
      try{ data = JSON.parse(text); }catch(e){ data = null; }
      console.log('Pricing API response:', data || text);
      if (data && data.prices) {
        state.summary.pricing = { 
          postcode: postcode || null, 
          zone_name: data.zone_name || 'Default', 
          matched_prefix: data.matched_prefix || null, 
          prices: data.prices 
        };
        console.log('Applied pricing zone:', data.zone_name);
      } else {
        // non-JSON or unexpected response - use Default zone fallback
        console.warn('Invalid API response, using Default zone fallback');
        state.summary.pricing = { 
          postcode: postcode || null, 
          zone_name: 'Default', 
          matched_prefix: null, 
          prices: { '4w': 20, '8w': 25 } 
        };
      }
      saveState(state);
    }catch(err){
      // fetch error / timeout — use Default zone fallback
      console.warn('Pricing API failed:', err.message || err);
      state.summary.pricing = { 
        postcode: postcode || null, 
        zone_name: 'Default', 
        matched_prefix: null, 
        prices: { '4w': 20, '8w': 25 } 
      };
      saveState(state);
    }

    // Now render selectable cards
    var pricing = state.summary.pricing || { prices: { '4w': 20, '8w': 25 }, zone_name: 'Default' };
    var prices = pricing.prices || { '4w': 20, '8w': 25 };
    // ensure selected defaults
    state.summary.selected_plan = state.summary.selected_plan || '4w';
    state.summary.selected_price = state.summary.selected_price || prices[state.summary.selected_plan] || prices['4w'];
    saveState(state);

    breakdown.innerHTML = '';
    var header = document.createElement('div');
    header.className = 'qs-pricing-header';
    // Replace the previous pricing zone label with the 'Your Quote' title + subtext
    header.innerHTML = '<div class="qs-quote-header">' +
      '<h2 class="qs-quote-header__title">Your Quote</h2>' +
      '<div class="qs-quote-header__sub">Please choose one of the quotes below.</div>' +
      '</div>';
    breakdown.appendChild(header);
    

    var cards = document.createElement('div'); cards.className = 'qs-pricing-cards';

    function makeCard(key, price){
      var card = document.createElement('button');
      card.type = 'button';
      card.className = 'qs-pricing-card';
      if (state.summary.selected_plan === key) card.classList.add('selected');
      // include a selected indicator (circle + label) at top of the card
      card.innerHTML = '<div class="qs-selected-indicator">' +
        '<span class="qs-circle"><span class="qs-check">✓</span></span>' +
        '<span class="qs-selected-label">Selected</span>' +
        '</div>' +
        '<div class="qs-pricing-row">' +
          '<div class="qs-pricing-title">Window Clean</div>' +
          '<div class="qs-pricing-price-inline">' + formatGBP(price) + '</div>' +
        '</div>' +
        '<div class="qs-pricing-divider" aria-hidden="true"></div>' +
        '<div class="qs-pricing-sub">Cleaned every ' + (key === '4w' ? '4 weeks' : '8 weeks') + '</div>';
      card.addEventListener('click', function(){
        state.summary.selected_plan = key;
        state.summary.selected_price = price;
        // update selected visuals
        qsa('.qs-pricing-card').forEach(function(c){ c.classList.remove('selected'); });
        card.classList.add('selected');
        // update totals display
        var sub = qs('#qs-subtotal'); if (sub) sub.textContent = formatGBP(price);
        var totalEl = qs('#qs-final-total'); if (totalEl) totalEl.textContent = formatGBP(price);
        saveState(state);
      });
      return card;
    }

    var card4 = makeCard('4w', prices['4w']);
    var card8 = makeCard('8w', prices['8w']);
    cards.appendChild(card4); cards.appendChild(card8);
    breakdown.appendChild(cards);

    // Subtotal / Total display
    var sums = document.createElement('div'); sums.className = 'qs-pricing-sums';
    sums.innerHTML = '<div>Sub Total: <span id="qs-subtotal">' + formatGBP(state.summary.selected_price) + '</span></div>' +
      '<div><strong>Total: <span id="qs-final-total">' + formatGBP(state.summary.selected_price) + '</span></strong></div>';
    breakdown.appendChild(sums);

    // Add 'Your Quote' footer with Continue to Booking button and coupon dropdown (step 3 only)
    try{
      var footer = document.createElement('div'); footer.className = 'qs-quote-footer';

      // Booking controls container (no duplicate title/sub)
      var controls = document.createElement('div'); controls.className = 'qs-quote-footer__controls';
      var btn = document.createElement('button'); btn.type = 'button'; btn.className = 'qs-continue-button button'; btn.textContent = 'Continue to Booking';
      // advance to booking/payment (step 4)
      btn.addEventListener('click', function(){ try{ saveState(state); goToStep(4, state); }catch(e){ console.warn('continue to booking failed', e); } });
      controls.appendChild(btn);

      // Coupon dropdown: collapsible header that reveals an input + Apply button
      var couponWrap = document.createElement('div'); couponWrap.className = 'qs-quote-footer__coupon-wrap';
      var coupon = document.createElement('div'); coupon.className = 'qs-coupon';
      var header = document.createElement('button'); header.type = 'button'; header.className = 'qs-coupon__header'; header.textContent = 'Do you have a coupon code?';
      var body = document.createElement('div'); body.className = 'qs-coupon__body'; body.style.display = 'none';
      var input = document.createElement('input'); input.type = 'text'; input.placeholder = 'Enter code'; input.className = 'qs-coupon__input';
      var apply = document.createElement('button'); apply.type = 'button'; apply.className = 'qs-coupon__apply button'; apply.textContent = 'Apply';
      var msg = document.createElement('div'); msg.className = 'qs-coupon__msg'; msg.style.color = '#333'; msg.style.marginTop = '8px';
      body.appendChild(input); body.appendChild(apply); body.appendChild(msg);
      coupon.appendChild(header); coupon.appendChild(body);
      couponWrap.appendChild(coupon);
      controls.appendChild(couponWrap);

      // Toggle body visibility
      header.addEventListener('click', function(){
        try{
          if (body.style.display === 'none') { body.style.display = ''; coupon.classList.add('open'); }
          else { body.style.display = 'none'; coupon.classList.remove('open'); }
        }catch(e){ console.warn(e); }
      });

      // Apply coupon: persist to state.summary.coupon and show simple feedback
      apply.addEventListener('click', function(){
        try{
          var code = String(input.value || '').trim();
          var st = loadState() || {};
          st.summary = st.summary || {};
          if (!code) { msg.textContent = 'Please enter a code'; msg.style.color = '#c00'; return; }
          
          // Show loading state
          apply.setAttribute('disabled', 'disabled');
          apply.textContent = 'Checking...';
          msg.textContent = '';
          
          // Validate coupon with backend
          var validateEndpoint = 'https://yourlocalbackend.vercel.app/api/validate-coupon';
          var selectedPrice = st.summary.selected_price || 0;
          var amountInPence = Math.round(selectedPrice * 100);
          
          console.log('Validating coupon:', code);
          console.log('Selected price (GBP):', selectedPrice);
          console.log('Amount in pence:', amountInPence);
          
          fetch(validateEndpoint, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ code: code, amount: amountInPence })
          })
          .then(function(res){ return res.json(); })
          .then(function(data){
            console.log('Backend response:', data);
            apply.removeAttribute('disabled');
            apply.textContent = 'Apply';
            
            if (data && data.valid && data.discount_amount !== undefined) {
              st.summary.coupon = code;
              st.summary.discount_amount = data.discount_amount;
              st.summary.discount_type = data.discount_type || 'fixed';
              saveState(st);
              
              msg.textContent = 'Coupon applied'; 
              msg.style.color = '#0a0';
              
              // Update displayed totals
              var selectedPrice = st.summary.selected_price || 0; // This is in GBP (e.g., 30)
              var discountAmountPence = data.discount_amount || 0; // This is in pence (e.g., 1000)
              var discountAmountGBP = discountAmountPence / 100; // Convert to GBP (e.g., 10)
              var finalTotal = Math.max(0, selectedPrice - discountAmountGBP);
              
              console.log('Price calculation:', {
                selectedPrice: selectedPrice,
                discountPence: discountAmountPence,
                discountGBP: discountAmountGBP,
                finalTotal: finalTotal
              });
              
              var sub = qs('#qs-subtotal'); 
              if (sub) sub.textContent = formatGBP(selectedPrice);
              
              var totalEl = qs('#qs-final-total'); 
              if (totalEl) totalEl.textContent = formatGBP(finalTotal);
              
              // Show discount line if not already present
              var sumsEl = qs('.qs-pricing-sums');
              if (sumsEl) {
                var existingDiscount = qs('#qs-discount-line');
                if (existingDiscount) existingDiscount.remove();
                
                if (discountAmountGBP > 0) {
                  var discountLine = document.createElement('div');
                  discountLine.id = 'qs-discount-line';
                  discountLine.style.color = '#0a0';
                  discountLine.innerHTML = 'Discount (' + code + '): -<span id="qs-discount-amount">' + formatGBP(discountAmountGBP) + '</span>';
                  
                  var totalLine = sumsEl.querySelector('div:last-child');
                  if (totalLine) {
                    sumsEl.insertBefore(discountLine, totalLine);
                  }
                }
              }
              
              console.log('Applied coupon', code, 'discount:', discountAmount);
            } else {
              msg.textContent = data.message || 'Invalid coupon code'; 
              msg.style.color = '#c00';
            }
          })
          .catch(function(err){
            apply.removeAttribute('disabled');
            apply.textContent = 'Apply';
            msg.textContent = 'Error validating coupon'; 
            msg.style.color = '#c00';
            console.warn('coupon validation error', err);
          });
        }catch(e){ 
          console.warn('apply coupon failed', e); 
          msg.textContent = 'Error'; 
          apply.removeAttribute('disabled');
          apply.textContent = 'Apply';
        }
      });

      footer.appendChild(controls);
      breakdown.appendChild(footer);
    }catch(e){ console.warn('failed to render quote footer', e); }
  }

  function goToStep(n, state){
    // clamp 1-4
    n = Math.max(1, Math.min(4, n));
    showStep(n);
    state.currentStep = n; saveState(state);
    
    // Add to browser history so back button works
    var stepNames = ['', 'property', 'details', 'quote', 'payment'];
    var stepName = stepNames[n] || 'step' + n;
    var url = new URL(window.location);
    url.searchParams.set('step', n);
    window.history.pushState({ step: n }, '', url);
    
    // render summary when on step 3
    if (n === 3) renderSummary(state);
  }

  function onPay(state){
    var selected_price = (state.summary && state.summary.selected_price) || 0;
    var selected_plan = (state.summary && state.summary.selected_plan) || null;
    var payload = { quoteState: state, selected_price: selected_price, selected_plan: selected_plan };
    // Try real API, fallback to mock
    fetch('/api/stripe/create-checkout-session', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    }).then(function(res){
      return res.json();
    }).then(function(json){
      var url = json && (json.url || json.checkout_url);
      if (url) { window.location = url; return; }
      // fallback mock
      window.location = window.location.pathname + '?session_id=MOCK_' + (state.summary && state.summary.quoteId);
    }).catch(function(){
      // mock response for dev: redirect back to this page with session_id
      setTimeout(function(){
        window.location = window.location.pathname + '?session_id=MOCK_' + (state.summary && state.summary.quoteId);
      }, 700);
    });
  }

  // Initialize wizard
  function init(){
    // mark root as JS-enabled so CSS fallback for no-JS doesn't show
    var root = document.querySelector('.quote-steps');
    if (root) root.classList.add('js');

    var state = loadState();

    // Stripe setup (if section provides publishable key and auth endpoint)
    var sectionEl = root;
    var STRIPE_PUBLISHABLE_KEY = sectionEl && sectionEl.dataset && sectionEl.dataset.stripePk ? sectionEl.dataset.stripePk : null;
    var AUTH_ENDPOINT = sectionEl && sectionEl.dataset && sectionEl.dataset.authEndpoint ? sectionEl.dataset.authEndpoint : null;
    var stripe = null, stripeElements = null, cardNumber = null, cardCvc = null, cardExpiry = null;
    var SHOPIFY_ORDER_ENDPOINT = sectionEl && sectionEl.dataset && sectionEl.dataset.shopifyOrderEndpoint ? sectionEl.dataset.shopifyOrderEndpoint : null;
    var SHOPIFY_MARKPAID_ENDPOINT = sectionEl && sectionEl.dataset && sectionEl.dataset.shopifyMarkpaidEndpoint ? sectionEl.dataset.shopifyMarkpaidEndpoint : null;
    
    // Get loader animation URL from section dataset
    LOADER_ANIMATION_URL = sectionEl && sectionEl.dataset && sectionEl.dataset.loaderAnimation ? sectionEl.dataset.loaderAnimation : null;
    
    // allow overriding pricing endpoint from section dataset
    try{
      if (sectionEl && sectionEl.dataset && sectionEl.dataset.getPricingEndpoint) {
        GET_PRICING_ENDPOINT = sectionEl.dataset.getPricingEndpoint;
      }
    }catch(e){}
    function showCardError(msg){ var el = qs('#qs-card-errors'); if (el) el.textContent = msg || ''; }
        if (STRIPE_PUBLISHABLE_KEY && window.Stripe) {
      try{
        stripe = Stripe(STRIPE_PUBLISHABLE_KEY);
        stripeElements = stripe.elements();
        var mountNumber = qs('#qs-card-number');
        var mountCvc = qs('#qs-card-cvc');
        if (mountNumber) {
          cardNumber = stripeElements.create('cardNumber', { style: { base: { fontSize: '16px' } } });
          cardNumber.mount(mountNumber);
          cardNumber.on('change', function(ev){ showCardError(ev.error ? ev.error.message : ''); });
        }
        if (mountCvc) {
          cardCvc = stripeElements.create('cardCvc', { style: { base: { fontSize: '16px' } } });
          cardCvc.mount(mountCvc);
          cardCvc.on('change', function(ev){ showCardError(ev.error ? ev.error.message : ''); });
        }
        var mountExpiry = qs('#qs-card-expiry');
        if (mountExpiry) {
          cardExpiry = stripeElements.create('cardExpiry', { style: { base: { fontSize: '16px' } } });
          cardExpiry.mount(mountExpiry);
          cardExpiry.on('change', function(ev){ showCardError(ev.error ? ev.error.message : ''); });
        }
      }catch(e){ console.warn('Stripe init failed', e); }
    }

    // If returning from Stripe (session_id in query) show thank you view
    var sessionId = getQueryParam('session_id');
    if (sessionId){
      var ty = qs('#qs-thankyou');
      if (ty){ ty.style.display = 'flex'; }
      // optionally update message span if present
      var msg = qs('#qs-thankyou-message'); if (msg) msg.textContent = 'Payment confirmed (session ' + sessionId + '). Thank you!';
      // hide steps and controls
      var stepsWrap = qs('#qs-steps'); if (stepsWrap) { stepsWrap.style.display = 'block'; }
      // Remove active state from step 4 so it doesn't appear selected behind the thank-you card
      try{ var step4 = qs('.qs-step[data-step="4"]'); if (step4) step4.classList.remove('active'); }catch(e){}
      var controls = qs('.quote-steps__controls'); if (controls) controls.style.display = 'none';
      var header = qs('.quote-steps__header'); if (header) header.style.display = '';

      // wire account button to redirect to account page
      var acctBtn = qs('#qs-thankyou-account');
      if (acctBtn) {
        acctBtn.addEventListener('click', function(){
          try{ window.location.href = '/account'; }catch(e){ window.location = '/account'; }
        });
      }

      return;
    }

    // Helper: show the in-page thank you card without a full redirect
    function showLocalThankYou(setupIntentId, orderId){
      try{
        var ty = qs('#qs-thankyou'); if (ty) {
          ty.style.display = 'flex';
          try{ ty.style.zIndex = 9999; }catch(e){}
        }
        var msg = qs('#qs-thankyou-message'); if (msg) msg.textContent = 'Card verified successfully! Your booking is confirmed. We\'ll charge your card after completing the service.';
        // Keep the steps wrapper visible behind the thank-you card and ensure step 4 is not marked active
        var stepsWrap = qs('#qs-steps'); if (stepsWrap) { stepsWrap.style.display = 'block'; }
        try{ var step4 = qs('.qs-step[data-step="4"]'); if (step4) step4.classList.remove('active'); }catch(e){}
        var controls = qs('.quote-steps__controls'); if (controls) controls.style.display = 'none';
        var header = qs('.quote-steps__header'); if (header) header.style.display = '';
        // Optionally include order id in the thank you card (not currently present in markup)
        try{ if (orderId) { console.log('Order created:', orderId); } }catch(e){}
      }catch(e){console.warn('showLocalThankYou failed',e);}    
    }

    // Do NOT auto-show the thank-you from a persisted session flag.
    // The thank-you view should only be shown when a payment `session_id` is present
    // or when an in-page `qs:accountCreated` event is dispatched after a successful
    // account creation. Persisted flags can cause the thank-you to appear on other pages,
    // so we intentionally avoid reading `quote_account_created` here.

    // Listen for in-page account creation events to show the thank-you view without reload
    try{
      document.addEventListener('qs:accountCreated', function(e){
        try{
          console.log('qs:accountCreated event received', e && e.detail);
          var setupIntentId = (e && e.detail && e.detail.setupIntentId) || null;
          var orderId = (e && e.detail && e.detail.orderId) || (typeof sessionStorage !== 'undefined' ? sessionStorage.getItem('quote_order_id') : null) || null;
          console.log('qs: showing local thank you, orderId:', orderId, 'setupIntentId:', setupIntentId);
          showLocalThankYou(setupIntentId, orderId);
        }catch(err){ console.warn('qs:accountCreated handler error', err); }
      });
    }catch(e){ /* ignore */ }

    // Prefill address from querystring or existing state
    var qAddress = getQueryParam('address');
    if (qAddress){
      try{ qAddress = decodeURIComponent(qAddress); }catch(e){}
      
      // Always clear session when address comes from homepage to ensure fresh start
      console.log('Address from homepage, clearing old session and starting fresh');
      sessionStorage.removeItem(STORAGE_KEY);
      state = { currentStep: 1, service: {}, customer: {}, summary: {} };
      
      var addrEl = qs('#qs-address'); if (addrEl) addrEl.value = qAddress;
      state.service = state.service || {}; 
      state.service.address = qAddress;
      
      // Extract postcode from the prefilled address
      var postcode = null;
      var re = /([A-Z]{1,2}\d[A-Z\d]?\s*\d[A-Z]{2})/i;
      var m = qAddress.match(re);
      if (m && m[1]) {
        postcode = m[1].toUpperCase().trim();
        state.service.postcode = postcode;
        console.log('Extracted postcode from prefilled address:', postcode);
      }
      
      // Clear old pricing cache to force fresh fetch
      if (state.summary) {
        state.summary.pricing = null;
      }
      
      // ensure flow starts at step 1 when address provided via querystring
      state.currentStep = 1;
      saveState(state);
    } else if (state.service && state.service.address){
      var addrEl2 = qs('#qs-address'); if (addrEl2) addrEl2.value = state.service.address;
    }

    // Prefill customer fields from persisted state (first/last/email/phone/marketing)
    try{
      if (state && state.customer) {
        var cf = state.customer || {};
        var fEl = qs('#qs-first'); if (fEl && cf.first) fEl.value = cf.first;
        var lEl = qs('#qs-last');  if (lEl && cf.last) lEl.value = cf.last;
        var eEl = qs('#qs-email'); if (eEl && cf.email) eEl.value = cf.email;
        var pEl = qs('#qs-phone'); if (pEl && cf.phone) pEl.value = cf.phone;
        var aEl = qs('#qs-customer-address'); if (aEl && cf.address) aEl.value = cf.address;
        // also set primary address input if present
        var addrMain = qs('#qs-address'); if (addrMain && cf.address) addrMain.value = cf.address;
        // marketing opt-in checkbox (support both `marketing_optin` and legacy `marketing_opt_in` keys)
        var mEl = qs('#qs-marketing') || qs('#qs-marketing-optin') || qs('#qs-marketing-opt-in') || qs('input[name="marketing_opt_in"]') || qs('input[name="accepts_marketing"]') || qs('input[name="subscribe"]');
        try{
          var val = typeof cf.marketing_optin !== 'undefined' ? cf.marketing_optin : (typeof cf.marketing_opt_in !== 'undefined' ? cf.marketing_opt_in : undefined);
          if (mEl && typeof val !== 'undefined') { mEl.checked = !!val; }
        }catch(e){}
      }
    }catch(e){}

    // Wire tile selectors for property and windows (UI interactions)
    qsa('.qs-property-tiles .qs-tile').forEach(function(btn){
      btn.addEventListener('click', function(){
        var v = btn.getAttribute('data-value');
        // mark selected
        qsa('.qs-property-tiles .qs-tile').forEach(function(b){ b.classList.remove('selected'); });
        btn.classList.add('selected');
        var sel = qs('#qs-property-type'); if (sel) sel.value = v;
        // persist
        try{ var s = loadState(); s.service = s.service||{}; s.service.property = v; saveState(s);}catch(e){}
        // attempt to auto-advance from step 1 if all required fields present
        try{ if (typeof maybeAdvanceIfStep1Valid === 'function') maybeAdvanceIfStep1Valid(); }catch(e){}
      });
    });
    qsa('.qs-windows-tiles .qs-tile').forEach(function(btn){
      btn.addEventListener('click', function(){
        var v = btn.getAttribute('data-value');
        qsa('.qs-windows-tiles .qs-tile').forEach(function(b){ b.classList.remove('selected'); });
        btn.classList.add('selected');
        var win = qs('#qs-windows'); if (win) win.value = v;
        try{ var s = loadState(); s.service = s.service||{}; s.service.windows = parseInt(v,10) || 0; saveState(s);}catch(e){}
        // attempt to auto-advance from step 1 if all required fields present
        try{ if (typeof maybeAdvanceIfStep1Valid === 'function') maybeAdvanceIfStep1Valid(); }catch(e){}
      });
    });

    // recompute connectors on resize to handle responsive layout
    try{ window.addEventListener('resize', function(){ try{ updateConnectors(); }catch(e){} }); }catch(e){}

    // Auto-advance helper for Step 1: move to step 2 when Address, property, and windows are present
    var _qs_step1_timer = null;
    function maybeAdvanceIfStep1Valid(){
      try{
        if (_qs_step1_timer) clearTimeout(_qs_step1_timer);
        _qs_step1_timer = setTimeout(function(){
          try{
            var state = loadState() || {};
            var current = state.currentStep || 1;
            if (Number(current) !== 1) return;
            var addrEl = qs('#qs-address');
            var addr = addrEl && String(addrEl.value || '').trim();
            // Require that the user has actively selected a property tile and a windows tile
            var propSelected = qs('.qs-property-tiles .qs-tile.selected');
            var winSelected = qs('.qs-windows-tiles .qs-tile.selected');
            if (addr && propSelected && winSelected) {
              try{ state = collectStep1(state) || state; }catch(e){}
              try{ goToStep(2, state); }catch(e){}
              try{ var controls = qs('.quote-steps__controls'); if (controls) controls.style.display = 'none'; }catch(e){}
            }
          }catch(e){/* ignore */}
        }, 120);
      }catch(e){}
    }

    // wire address input to auto-advance check
    try{
      var addrInput = qs('#qs-address');
      if (addrInput) {
        addrInput.addEventListener('input', maybeAdvanceIfStep1Valid);
        addrInput.addEventListener('blur', maybeAdvanceIfStep1Valid);
      }
    }catch(e){}

    // Wire the step-2 "Get my quote" buttons (class .qs-next) to validate and advance to step 3
    try{
      function showStep2Errors(html){
        try{ var el = qs('#qs-step2-errors'); if (!el) return; el.innerHTML = html || ''; }catch(e){}
      }

      function validateStep2(){
        var valid = true;
        var firstEl = qs('#qs-first'); var lastEl = qs('#qs-last'); var emailEl = qs('#qs-email'); var phoneEl = qs('#qs-phone');
        // reset styles
        [firstEl, lastEl, emailEl, phoneEl].forEach(function(i){ if (!i) return; i.style.borderColor = ''; i.removeAttribute('aria-invalid'); });
        var errors = [];
        var first = firstEl && String(firstEl.value || '').trim();
        var last  = lastEl && String(lastEl.value || '').trim();
        var email = emailEl && String(emailEl.value || '').trim();
        var phone = phoneEl && String(phoneEl.value || '').trim();
        if (!first) { valid = false; errors.push('First name is required'); if (firstEl) { firstEl.style.borderColor = '#c00'; firstEl.setAttribute('aria-invalid','true'); } }
        if (!last)  { valid = false; errors.push('Last name is required'); if (lastEl)  { lastEl.style.borderColor = '#c00'; lastEl.setAttribute('aria-invalid','true'); } }
        if (!email) { valid = false; errors.push('Email is required'); if (emailEl) { emailEl.style.borderColor = '#c00'; emailEl.setAttribute('aria-invalid','true'); } }
        else {
          // basic email check
          var re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
          if (!re.test(email)) { valid = false; errors.push('Enter a valid email address'); if (emailEl) { emailEl.style.borderColor = '#c00'; emailEl.setAttribute('aria-invalid','true'); } }
        }
        if (!phone) { valid = false; errors.push('Phone is required'); if (phoneEl) { phoneEl.style.borderColor = '#c00'; phoneEl.setAttribute('aria-invalid','true'); } }

        if (!valid) {
          var html = '<div class="qs-create-fail">' + errors.map(function(e){ return '<div>' + e + '</div>'; }).join('') + '</div>';
          showStep2Errors(html);
        } else {
          showStep2Errors('');
        }
        return valid;
      }

      qsa('.qs-next').forEach(function(btn){
        btn.addEventListener('click', function(ev){
          try{
            // Only run validation for the 'Get my quote' button when on step 2
            var s = loadState();
            var step = (s && s.currentStep) || qs('#qs-current') && Number(qs('#qs-current').textContent) || 1;
            if (Number(step) === 2) {
              if (!validateStep2()) { return; }
            }
            s = collectStep2(s) || s;
            // fire preflight upsert (non-blocking) so backend has email/phone before consent mutation
            try{ upsertCustomerPreflight(s); }catch(e){}
            goToStep(3, s);
            var controls = qs('.quote-steps__controls'); if (controls) controls.style.display = 'none';
          }catch(e){ console.warn('qs-next handler failed', e); }
        });
      });
    }catch(e){}

    // Save first/last to sessionStorage on blur so Step 4 can read them (no passwords stored)
    try{
      var firstInput = qs('#qs-first');
      var lastInput  = qs('#qs-last');
      if (firstInput) firstInput.addEventListener('blur', function(){
        try{ var v = (firstInput.value||'').trim(); sessionStorage.setItem('quote_customer_first', v); }
        catch(e){}
      });
      if (lastInput) lastInput.addEventListener('blur', function(){
        try{ var v = (lastInput.value||'').trim(); sessionStorage.setItem('quote_customer_last', v); }
        catch(e){}
      });
    }catch(e){}

    // If previously in progress, restore currentStep
    var current = state.currentStep || 1;
    showStep(current);

    // Wire buttons
    var next = qs('#qs-next'); var back = qs('#qs-back'); var pay = qs('#qs-pay');
    if (next) next.addEventListener('click', function(){
      var s = loadState();
      var step = s.currentStep || current;
      if (step === 1){ s = collectStep1(s); goToStep(2,s); }
      else if (step === 2){ s = collectStep2(s); try{ upsertCustomerPreflight(s); }catch(e){}; goToStep(3,s); }
      else if (step === 3){ goToStep(4, s); }
    });
    if (back) back.addEventListener('click', function(){
      var s = loadState(); var step = s.currentStep || current; goToStep(step-1, s);
    });
    if (pay) pay.addEventListener('click', function(){
      var s = loadState();
      // keep a stable snapshot available in inner promise scopes
      var latestState = s || loadState() || {};
      // If Stripe Elements available, verify card and save for later payment
      if (stripe && cardNumber) {
        // Full flow: create SetupIntent on server (£0 verification), confirm with Stripe, save card, then create Shopify order
        var actionMsg = qs('#qs-card-action-msg'); if (actionMsg) { actionMsg.innerHTML = ''; }
        showCardError('');
        s = collectStep2(s) || s;
        var email = (s.customer && s.customer.email) || '';
        if (!email || String(email).trim() === '') {
          if (actionMsg) { actionMsg.innerHTML = '<div class="qs-card-error">Please enter your email before adding a card</div>'; }
          return;
        }
        // Ensure we attempt a preflight upsert when the user creates an account so phone/email exist
        try{
          var createBtn = qs('#qs-create-account-btn');
          if (createBtn) {
            createBtn.addEventListener('click', function(){
              try{ var s = loadState() || {}; try{ upsertCustomerPreflight(s); }catch(e){} }catch(e){}
            });
          }
        }catch(e){}

        var selected_price = (s.summary && s.summary.selected_price) || 0;
        var selected_plan = (s.summary && s.summary.selected_plan) || null;
        var discount_amount = (s.summary && s.summary.discount_amount) || 0;
        var final_price = Math.max(0, selected_price - discount_amount);
        var amount_minor = Math.round(Number(final_price) * 100);
        if (!amount_minor || amount_minor <= 0) {
          if (actionMsg) { actionMsg.innerHTML = '<div class="qs-card-error">Invalid amount. Must be greater than 0</div>'; }
          return;
        }

        try{ pay.setAttribute('disabled','disabled'); pay.classList.add('processing'); }catch(e){}

        // Update status message
        if (actionMsg) { actionMsg.innerHTML = '<div class="qs-card-processing">Verifying your card...</div>'; }

        fetch('https://yourlocalbackend.vercel.app/api/create-card-setup', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            customer_email: email,
            customer_name: (s && s.customer) ? ((s.customer.first || '') + ' ' + (s.customer.last || '')).trim() : null,
            customer_phone: (s && s.customer && s.customer.phone) || null
          })
        }).then(function(res){ return res.json(); }).then(function(json){
          var clientSecret = json && (json.clientSecret || json.client_secret);
          if (!clientSecret) throw new Error((json && (json.error || json.message)) || 'No client secret returned');
          var stripeCustomerId = json && (json.customer_id || json.customerId);
          var setupIntentId = json && (json.setup_intent_id || json.setupIntentId || json.id);

          // Build billing details
          var billing_postcode = (qs('#qs-card-postcode') && qs('#qs-card-postcode').value) || getPostcode(s) || undefined;
          var addressLine1 = (s && s.customer && s.customer.address) || (s && s.service && s.service.address) || undefined;
          var billingDetails = {
            name: ((s.customer && ((s.customer.first||'') + ' ' + (s.customer.last||''))).trim() || undefined),
            email: (s.customer && s.customer.email) || undefined,
            phone: (s.customer && s.customer.phone) || undefined
          };
          if (addressLine1 || billing_postcode) {
            billingDetails.address = {};
            if (addressLine1) billingDetails.address.line1 = addressLine1;
            if (billing_postcode) billingDetails.address.postal_code = billing_postcode;
            billingDetails.address.country = 'GB';
          }

          // Confirm SetupIntent (£0 card verification)
          return stripe.confirmCardSetup(clientSecret, {
            payment_method: {
              card: cardNumber,
              billing_details: billingDetails
            }
          }).then(function(result){
              if (result && result.error) {
                var em = result.error && result.error.message ? result.error.message : 'Card verification failed';
                if (actionMsg) { actionMsg.innerHTML = '<div class="qs-card-error">' + em + '</div>'; }
                showCardError(em);
                throw result.error;
              }
              var paymentMethodId = (result && result.setupIntent && result.setupIntent.payment_method) || null;
              var setupId = (result && result.setupIntent && result.setupIntent.id) || setupIntentId;
              // Store payment method details
              try{
                var stored = loadState() || {};
                stored.summary = stored.summary || {};
                stored.summary.setup_intent_id = setupId;
                stored.summary.payment_method_id = paymentMethodId;
                stored.summary.stripe_customer_id = stripeCustomerId;
                saveState(stored);
              }catch(e){}
              try{ sessionStorage.setItem('quote_card_added','1'); }catch(e){}
              try{ document.dispatchEvent(new CustomEvent('qs:cardAdded')); }catch(e){}

              // Update status message
              if (actionMsg) { actionMsg.innerHTML = '<div class="qs-card-success">✅ Card verified successfully! Creating your booking...</div>'; }

              // Build order payload and POST to SHOPIFY_ORDER_ENDPOINT
              if (!SHOPIFY_ORDER_ENDPOINT) {
                if (actionMsg) { actionMsg.innerHTML = '<div class="qs-card-success">Card verified. Order endpoint not configured.</div>'; }
                // Do not redirect — keep user on the page and show success message
                return;
              }
              // use the `latestState` snapshot defined earlier
              latestState = latestState || loadState() || {};
              var orderPayload = {
                email: (latestState.customer && latestState.customer.email) || '',
                first_name: (latestState.customer && latestState.customer.first) || '',
                last_name: (latestState.customer && latestState.customer.last) || '',
                phone: (latestState.customer && latestState.customer.phone) || '',
                address: (latestState.customer && latestState.customer.address) || (latestState.service && latestState.service.address) || null,
                marketing_opt_in: (latestState.customer && (typeof latestState.customer.marketing_opt_in !== 'undefined' ? latestState.customer.marketing_opt_in : (typeof latestState.customer.marketing_optin !== 'undefined' ? latestState.customer.marketing_optin : null))) ,
                marketing_optin: !!(latestState.customer && (typeof latestState.customer.marketing_optin !== 'undefined' ? latestState.customer.marketing_optin : latestState.customer.marketing_opt_in)),
                accepts_marketing: !!(latestState.customer && (typeof latestState.customer.marketing_optin !== 'undefined' ? latestState.customer.marketing_optin : latestState.customer.marketing_opt_in)),
                quantity: 1,
                note: 'Quote checkout',
                selected_price_gbp: Number(final_price || (latestState.summary && latestState.summary.selected_price) || selected_price || 0),
                original_price_gbp: Number((latestState.summary && latestState.summary.selected_price) || selected_price || 0),
                discount_amount_gbp: Number((latestState.summary && latestState.summary.discount_amount) || 0),
                selected_plan: (latestState.summary && latestState.summary.selected_plan) || selected_plan || null,
                postcode: getPostcode(latestState) || null,
                zone_name: (latestState.summary && latestState.summary.pricing && latestState.summary.pricing.zone_name) || null,
                stripe_customer_id: stripeCustomerId,
                stripe_payment_method_id: paymentMethodId,
                setup_intent_id: setupId
              };
              try{ orderPayload.quoteState = latestState; }catch(e){}
              if (latestState && latestState.summary && latestState.summary.coupon) {
                orderPayload.coupon = latestState.summary.coupon;
                orderPayload.discount_code = latestState.summary.coupon;
              }

              return fetch(SHOPIFY_ORDER_ENDPOINT, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(orderPayload) })
                .then(function(res){ return res.text().then(function(text){ var respJson=null; try{ respJson=JSON.parse(text);}catch(e){ respJson={text:text}; } return {status: res.status, ok: res.ok, body: respJson}; }); });
            }).then(function(orderResp){
              // If the previous then returned an order response, handle it
              if (orderResp) {
                if (!orderResp.ok) {
                  var msg = (orderResp.body && (orderResp.body.error || orderResp.body.message)) || ('Order creation failed: HTTP ' + orderResp.status);
                  if (actionMsg) { actionMsg.innerHTML = '<div class="qs-card-error">' + msg + '</div>'; }
                  showCardError(msg);
                  throw new Error(msg);
                }
                var orderId = orderResp.body && (orderResp.body.order_id || orderResp.body.id);
                if (actionMsg) { actionMsg.innerHTML = '<div class="qs-card-success">✅ Booking created successfully! Card saved for payment after service completion.</div>'; }
                // Persist order id locally and keep user on the page (no redirect)
                try{
                  var stored2 = loadState() || {}; stored2.summary = stored2.summary || {}; stored2.summary.order_id = orderId || null; saveState(stored2);
                  try{ if (orderId) sessionStorage.setItem('quote_order_id', String(orderId)); }catch(e){}
                }catch(e){ console.warn('persist order id failed', e); }
                // keep the success message visible and do not navigate away
              }
            });
        }).catch(function(err){
          var em = err && err.message ? err.message : 'An error occurred. Please try again.';
          // Make error messages more user-friendly
          if (em.toLowerCase().includes('network')) {
            em = 'Network error. Please check your connection and try again.';
          } else if (em.toLowerCase().includes('declined')) {
            em = 'Your card was declined. Please try a different card.';
          }
          var actionMsgEl = qs('#qs-card-action-msg');
          if (actionMsgEl) actionMsgEl.innerHTML = '<div class="qs-card-error">❌ ' + em + '</div>';
          showCardError(em);
          console.error('Card setup error:', err);
        }).finally(function(){ try{ pay.removeAttribute('disabled'); pay.classList.remove('processing'); }catch(e){} });
        return;
      }
      // fallback to original onPay behavior
      onPay(s);
    });

    // initial render of summary if needed
    if (current === 3) renderSummary(state);
    
    // Handle browser back/forward buttons
    window.addEventListener('popstate', function(event) {
      if (event.state && event.state.step) {
        var state = loadState();
        showStep(event.state.step);
        state.currentStep = event.state.step;
        saveState(state);
        if (event.state.step === 3) renderSummary(state);
      }
    });
    
    // Set initial history state
    var url = new URL(window.location);
    var urlStep = parseInt(url.searchParams.get('step')) || current;
    window.history.replaceState({ step: urlStep }, '', url);
  }

  // DOM ready
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();

})();
